// Generated from AponoQuery.g4 by ANTLR 4.13.2
// noinspection ES6UnusedImports,JSUnusedGlobalSymbols,JSUnusedLocalSymbols

import {
	ATN,
	ATNDeserializer, DecisionState, DFA, FailedPredicateException,
	RecognitionException, NoViableAltException, BailErrorStrategy,
	Parser, ParserATNSimulator,
	RuleContext, ParserRuleContext, PredictionMode, PredictionContextCache,
	TerminalNode, RuleNode,
	Token, TokenStream,
	Interval, IntervalSet
} from 'antlr4';
import AponoQueryListener from "./AponoQueryListener.js";
// for running tests with parameters, TODO: discuss strategy for typed parameters in CI
// eslint-disable-next-line no-unused-vars
type int = number;

export default class AponoQueryParser extends Parser {
	public static readonly T__0 = 1;
	public static readonly T__1 = 2;
	public static readonly T__2 = 3;
	public static readonly T__3 = 4;
	public static readonly T__4 = 5;
	public static readonly Equals = 6;
	public static readonly NotEquals = 7;
	public static readonly Contains = 8;
	public static readonly NotContains = 9;
	public static readonly StartsWith = 10;
	public static readonly EndsWith = 11;
	public static readonly In = 12;
	public static readonly NotIn = 13;
	public static readonly And = 14;
	public static readonly Or = 15;
	public static readonly Not = 16;
	public static readonly ResourceName = 17;
	public static readonly Resource = 18;
	public static readonly ResourceType = 19;
	public static readonly Integration = 20;
	public static readonly IntegrationName = 21;
	public static readonly ResourceTag = 22;
	public static readonly ResourceContext = 23;
	public static readonly ResourceStatus = 24;
	public static readonly ResourceRiskLevel = 25;
	public static readonly Permission = 26;
	public static readonly PermissionName = 27;
	public static readonly PermissionTag = 28;
	public static readonly PermissionContext = 29;
	public static readonly PermissionRiskLevel = 30;
	public static readonly QuotedString = 31;
	public static readonly WS = 32;
	public static override readonly EOF = Token.EOF;
	public static readonly RULE_query = 0;
	public static readonly RULE_field = 1;
	public static readonly RULE_idField = 2;
	public static readonly RULE_nameField = 3;
	public static readonly RULE_equalsOperator = 4;
	public static readonly RULE_substringOperator = 5;
	public static readonly RULE_inOperator = 6;
	public static readonly RULE_stringValue = 7;
	public static readonly RULE_stringValues = 8;
	public static readonly literalNames: (string | null)[] = [ null, "'('", 
                                                            "')'", "'['", 
                                                            "']'", "','", 
                                                            "'='", "'!='", 
                                                            "'contains'", 
                                                            "'not_contains'", 
                                                            "'starts_with'", 
                                                            "'ends_with'", 
                                                            "'in'", "'not_in'", 
                                                            null, null, 
                                                            null, "'resource_name'", 
                                                            "'resource'", 
                                                            "'resource_type'", 
                                                            "'integration'", 
                                                            "'integration_name'", 
                                                            "'resource_tag'", 
                                                            "'resource_context'", 
                                                            "'resource_status'", 
                                                            "'resource_risk_level'", 
                                                            "'permission'", 
                                                            "'permission_name'", 
                                                            "'permission_tag'", 
                                                            "'permission_context'", 
                                                            "'permission_risk_level'" ];
	public static readonly symbolicNames: (string | null)[] = [ null, null, 
                                                             null, null, 
                                                             null, null, 
                                                             "Equals", "NotEquals", 
                                                             "Contains", 
                                                             "NotContains", 
                                                             "StartsWith", 
                                                             "EndsWith", 
                                                             "In", "NotIn", 
                                                             "And", "Or", 
                                                             "Not", "ResourceName", 
                                                             "Resource", 
                                                             "ResourceType", 
                                                             "Integration", 
                                                             "IntegrationName", 
                                                             "ResourceTag", 
                                                             "ResourceContext", 
                                                             "ResourceStatus", 
                                                             "ResourceRiskLevel", 
                                                             "Permission", 
                                                             "PermissionName", 
                                                             "PermissionTag", 
                                                             "PermissionContext", 
                                                             "PermissionRiskLevel", 
                                                             "QuotedString", 
                                                             "WS" ];
	// tslint:disable:no-trailing-whitespace
	public static readonly ruleNames: string[] = [
		"query", "field", "idField", "nameField", "equalsOperator", "substringOperator", 
		"inOperator", "stringValue", "stringValues",
	];
	public get grammarFileName(): string { return "AponoQuery.g4"; }
	public get literalNames(): (string | null)[] { return AponoQueryParser.literalNames; }
	public get symbolicNames(): (string | null)[] { return AponoQueryParser.symbolicNames; }
	public get ruleNames(): string[] { return AponoQueryParser.ruleNames; }
	public get serializedATN(): number[] { return AponoQueryParser._serializedATN; }

	protected createFailedPredicateException(predicate?: string, message?: string): FailedPredicateException {
		return new FailedPredicateException(this, predicate, message);
	}

	constructor(input: TokenStream) {
		super(input);
		this._interp = new ParserATNSimulator(this, AponoQueryParser._ATN, AponoQueryParser.DecisionsToDFA, new PredictionContextCache());
	}

	public query(): QueryContext;
	public query(_p: number): QueryContext;
	// @RuleVersion(0)
	public query(_p?: number): QueryContext {
		if (_p === undefined) {
			_p = 0;
		}

		let _parentctx: ParserRuleContext = this._ctx;
		let _parentState: number = this.state;
		let localctx: QueryContext = new QueryContext(this, this._ctx, _parentState);
		let _prevctx: QueryContext = localctx;
		let _startState: number = 0;
		this.enterRecursionRule(localctx, 0, AponoQueryParser.RULE_query, _p);
		try {
			let _alt: number;
			this.enterOuterAlt(localctx, 1);
			{
			this.state = 45;
			this._errHandler.sync(this);
			switch ( this._interp.adaptivePredict(this._input, 0, this._ctx) ) {
			case 1:
				{
				localctx = new IdFieldEqualsOperatorQueryContext(this, localctx);
				this._ctx = localctx;
				_prevctx = localctx;

				this.state = 19;
				this.idField();
				this.state = 20;
				this.equalsOperator();
				this.state = 21;
				this.stringValue();
				}
				break;
			case 2:
				{
				localctx = new IdFieldInOperatorQueryContext(this, localctx);
				this._ctx = localctx;
				_prevctx = localctx;
				this.state = 23;
				this.idField();
				this.state = 24;
				this.inOperator();
				this.state = 25;
				this.stringValues();
				}
				break;
			case 3:
				{
				localctx = new NameFieldEqualsOperatorQueryContext(this, localctx);
				this._ctx = localctx;
				_prevctx = localctx;
				this.state = 27;
				this.nameField();
				this.state = 28;
				this.equalsOperator();
				this.state = 29;
				this.stringValue();
				}
				break;
			case 4:
				{
				localctx = new NameFieldInOperatorQueryContext(this, localctx);
				this._ctx = localctx;
				_prevctx = localctx;
				this.state = 31;
				this.nameField();
				this.state = 32;
				this.inOperator();
				this.state = 33;
				this.stringValues();
				}
				break;
			case 5:
				{
				localctx = new NameFieldSubstringOperatorQueryContext(this, localctx);
				this._ctx = localctx;
				_prevctx = localctx;
				this.state = 35;
				this.nameField();
				this.state = 36;
				this.substringOperator();
				this.state = 37;
				this.stringValue();
				}
				break;
			case 6:
				{
				localctx = new NotQueryContext(this, localctx);
				this._ctx = localctx;
				_prevctx = localctx;
				this.state = 39;
				this.match(AponoQueryParser.Not);
				this.state = 40;
				this.query(4);
				}
				break;
			case 7:
				{
				localctx = new ParenthesisQueryContext(this, localctx);
				this._ctx = localctx;
				_prevctx = localctx;
				this.state = 41;
				this.match(AponoQueryParser.T__0);
				this.state = 42;
				this.query(0);
				this.state = 43;
				this.match(AponoQueryParser.T__1);
				}
				break;
			}
			this._ctx.stop = this._input.LT(-1);
			this.state = 55;
			this._errHandler.sync(this);
			_alt = this._interp.adaptivePredict(this._input, 2, this._ctx);
			while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
				if (_alt === 1) {
					if (this._parseListeners != null) {
						this.triggerExitRuleEvent();
					}
					_prevctx = localctx;
					{
					this.state = 53;
					this._errHandler.sync(this);
					switch ( this._interp.adaptivePredict(this._input, 1, this._ctx) ) {
					case 1:
						{
						localctx = new AndQueryContext(this, new QueryContext(this, _parentctx, _parentState));
						this.pushNewRecursionContext(localctx, _startState, AponoQueryParser.RULE_query);
						this.state = 47;
						if (!(this.precpred(this._ctx, 3))) {
							throw this.createFailedPredicateException("this.precpred(this._ctx, 3)");
						}
						this.state = 48;
						this.match(AponoQueryParser.And);
						this.state = 49;
						this.query(4);
						}
						break;
					case 2:
						{
						localctx = new OrQueryContext(this, new QueryContext(this, _parentctx, _parentState));
						this.pushNewRecursionContext(localctx, _startState, AponoQueryParser.RULE_query);
						this.state = 50;
						if (!(this.precpred(this._ctx, 2))) {
							throw this.createFailedPredicateException("this.precpred(this._ctx, 2)");
						}
						this.state = 51;
						this.match(AponoQueryParser.Or);
						this.state = 52;
						this.query(3);
						}
						break;
					}
					}
				}
				this.state = 57;
				this._errHandler.sync(this);
				_alt = this._interp.adaptivePredict(this._input, 2, this._ctx);
			}
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.unrollRecursionContexts(_parentctx);
		}
		return localctx;
	}
	// @RuleVersion(0)
	public field(): FieldContext {
		let localctx: FieldContext = new FieldContext(this, this._ctx, this.state);
		this.enterRule(localctx, 2, AponoQueryParser.RULE_field);
		try {
			this.state = 60;
			this._errHandler.sync(this);
			switch (this._input.LA(1)) {
			case 18:
			case 19:
			case 20:
			case 24:
			case 25:
			case 26:
			case 30:
				localctx = new IdFieldTypeContext(this, localctx);
				this.enterOuterAlt(localctx, 1);
				{
				this.state = 58;
				this.idField();
				}
				break;
			case 17:
			case 21:
			case 22:
			case 23:
			case 27:
			case 28:
			case 29:
				localctx = new NameFieldTypeContext(this, localctx);
				this.enterOuterAlt(localctx, 2);
				{
				this.state = 59;
				this.nameField();
				}
				break;
			default:
				throw new NoViableAltException(this);
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return localctx;
	}
	// @RuleVersion(0)
	public idField(): IdFieldContext {
		let localctx: IdFieldContext = new IdFieldContext(this, this._ctx, this.state);
		this.enterRule(localctx, 4, AponoQueryParser.RULE_idField);
		try {
			this.state = 69;
			this._errHandler.sync(this);
			switch (this._input.LA(1)) {
			case 19:
				localctx = new ResourceTypeFieldContext(this, localctx);
				this.enterOuterAlt(localctx, 1);
				{
				this.state = 62;
				this.match(AponoQueryParser.ResourceType);
				}
				break;
			case 20:
				localctx = new IntegrationFieldContext(this, localctx);
				this.enterOuterAlt(localctx, 2);
				{
				this.state = 63;
				this.match(AponoQueryParser.Integration);
				}
				break;
			case 18:
				localctx = new ResourceFieldContext(this, localctx);
				this.enterOuterAlt(localctx, 3);
				{
				this.state = 64;
				this.match(AponoQueryParser.Resource);
				}
				break;
			case 24:
				localctx = new ResourceStatusFieldContext(this, localctx);
				this.enterOuterAlt(localctx, 4);
				{
				this.state = 65;
				this.match(AponoQueryParser.ResourceStatus);
				}
				break;
			case 25:
				localctx = new ResourceRiskLevelFieldContext(this, localctx);
				this.enterOuterAlt(localctx, 5);
				{
				this.state = 66;
				this.match(AponoQueryParser.ResourceRiskLevel);
				}
				break;
			case 26:
				localctx = new PermissionContext(this, localctx);
				this.enterOuterAlt(localctx, 6);
				{
				this.state = 67;
				this.match(AponoQueryParser.Permission);
				}
				break;
			case 30:
				localctx = new PermissionRiskLevelFieldContext(this, localctx);
				this.enterOuterAlt(localctx, 7);
				{
				this.state = 68;
				this.match(AponoQueryParser.PermissionRiskLevel);
				}
				break;
			default:
				throw new NoViableAltException(this);
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return localctx;
	}
	// @RuleVersion(0)
	public nameField(): NameFieldContext {
		let localctx: NameFieldContext = new NameFieldContext(this, this._ctx, this.state);
		this.enterRule(localctx, 6, AponoQueryParser.RULE_nameField);
		try {
			this.state = 94;
			this._errHandler.sync(this);
			switch (this._input.LA(1)) {
			case 21:
				localctx = new IntegrationNameFieldContext(this, localctx);
				this.enterOuterAlt(localctx, 1);
				{
				this.state = 71;
				this.match(AponoQueryParser.IntegrationName);
				}
				break;
			case 17:
				localctx = new ResourceNameFieldContext(this, localctx);
				this.enterOuterAlt(localctx, 2);
				{
				this.state = 72;
				this.match(AponoQueryParser.ResourceName);
				}
				break;
			case 27:
				localctx = new PermissionNameFieldContext(this, localctx);
				this.enterOuterAlt(localctx, 3);
				{
				this.state = 73;
				this.match(AponoQueryParser.PermissionName);
				}
				break;
			case 22:
				localctx = new ResourceTagFieldContext(this, localctx);
				this.enterOuterAlt(localctx, 4);
				{
				this.state = 74;
				this.match(AponoQueryParser.ResourceTag);
				this.state = 75;
				this.match(AponoQueryParser.T__2);
				this.state = 76;
				this.stringValue();
				this.state = 77;
				this.match(AponoQueryParser.T__3);
				}
				break;
			case 23:
				localctx = new ResourceContextFieldContext(this, localctx);
				this.enterOuterAlt(localctx, 5);
				{
				this.state = 79;
				this.match(AponoQueryParser.ResourceContext);
				this.state = 80;
				this.match(AponoQueryParser.T__2);
				this.state = 81;
				this.stringValue();
				this.state = 82;
				this.match(AponoQueryParser.T__3);
				}
				break;
			case 28:
				localctx = new PermissionTagFieldContext(this, localctx);
				this.enterOuterAlt(localctx, 6);
				{
				this.state = 84;
				this.match(AponoQueryParser.PermissionTag);
				this.state = 85;
				this.match(AponoQueryParser.T__2);
				this.state = 86;
				this.stringValue();
				this.state = 87;
				this.match(AponoQueryParser.T__3);
				}
				break;
			case 29:
				localctx = new PermissionContextFieldContext(this, localctx);
				this.enterOuterAlt(localctx, 7);
				{
				this.state = 89;
				this.match(AponoQueryParser.PermissionContext);
				this.state = 90;
				this.match(AponoQueryParser.T__2);
				this.state = 91;
				this.stringValue();
				this.state = 92;
				this.match(AponoQueryParser.T__3);
				}
				break;
			default:
				throw new NoViableAltException(this);
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return localctx;
	}
	// @RuleVersion(0)
	public equalsOperator(): EqualsOperatorContext {
		let localctx: EqualsOperatorContext = new EqualsOperatorContext(this, this._ctx, this.state);
		this.enterRule(localctx, 8, AponoQueryParser.RULE_equalsOperator);
		try {
			this.state = 98;
			this._errHandler.sync(this);
			switch (this._input.LA(1)) {
			case 6:
				localctx = new EqualsContext(this, localctx);
				this.enterOuterAlt(localctx, 1);
				{
				this.state = 96;
				this.match(AponoQueryParser.Equals);
				}
				break;
			case 7:
				localctx = new NotEqualsContext(this, localctx);
				this.enterOuterAlt(localctx, 2);
				{
				this.state = 97;
				this.match(AponoQueryParser.NotEquals);
				}
				break;
			default:
				throw new NoViableAltException(this);
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return localctx;
	}
	// @RuleVersion(0)
	public substringOperator(): SubstringOperatorContext {
		let localctx: SubstringOperatorContext = new SubstringOperatorContext(this, this._ctx, this.state);
		this.enterRule(localctx, 10, AponoQueryParser.RULE_substringOperator);
		try {
			this.state = 104;
			this._errHandler.sync(this);
			switch (this._input.LA(1)) {
			case 8:
				localctx = new ContainsContext(this, localctx);
				this.enterOuterAlt(localctx, 1);
				{
				this.state = 100;
				this.match(AponoQueryParser.Contains);
				}
				break;
			case 9:
				localctx = new NotContainsContext(this, localctx);
				this.enterOuterAlt(localctx, 2);
				{
				this.state = 101;
				this.match(AponoQueryParser.NotContains);
				}
				break;
			case 10:
				localctx = new StartsWithContext(this, localctx);
				this.enterOuterAlt(localctx, 3);
				{
				this.state = 102;
				this.match(AponoQueryParser.StartsWith);
				}
				break;
			case 11:
				localctx = new EndsWithContext(this, localctx);
				this.enterOuterAlt(localctx, 4);
				{
				this.state = 103;
				this.match(AponoQueryParser.EndsWith);
				}
				break;
			default:
				throw new NoViableAltException(this);
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return localctx;
	}
	// @RuleVersion(0)
	public inOperator(): InOperatorContext {
		let localctx: InOperatorContext = new InOperatorContext(this, this._ctx, this.state);
		this.enterRule(localctx, 12, AponoQueryParser.RULE_inOperator);
		try {
			this.state = 108;
			this._errHandler.sync(this);
			switch (this._input.LA(1)) {
			case 12:
				localctx = new InContext(this, localctx);
				this.enterOuterAlt(localctx, 1);
				{
				this.state = 106;
				this.match(AponoQueryParser.In);
				}
				break;
			case 13:
				localctx = new NotInContext(this, localctx);
				this.enterOuterAlt(localctx, 2);
				{
				this.state = 107;
				this.match(AponoQueryParser.NotIn);
				}
				break;
			default:
				throw new NoViableAltException(this);
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return localctx;
	}
	// @RuleVersion(0)
	public stringValue(): StringValueContext {
		let localctx: StringValueContext = new StringValueContext(this, this._ctx, this.state);
		this.enterRule(localctx, 14, AponoQueryParser.RULE_stringValue);
		try {
			this.enterOuterAlt(localctx, 1);
			{
			this.state = 110;
			this.match(AponoQueryParser.QuotedString);
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return localctx;
	}
	// @RuleVersion(0)
	public stringValues(): StringValuesContext {
		let localctx: StringValuesContext = new StringValuesContext(this, this._ctx, this.state);
		this.enterRule(localctx, 16, AponoQueryParser.RULE_stringValues);
		let _la: number;
		try {
			this.enterOuterAlt(localctx, 1);
			{
			this.state = 112;
			this.match(AponoQueryParser.T__0);
			this.state = 113;
			this.stringValue();
			this.state = 118;
			this._errHandler.sync(this);
			_la = this._input.LA(1);
			while (_la===5) {
				{
				{
				this.state = 114;
				this.match(AponoQueryParser.T__4);
				this.state = 115;
				this.stringValue();
				}
				}
				this.state = 120;
				this._errHandler.sync(this);
				_la = this._input.LA(1);
			}
			this.state = 121;
			this.match(AponoQueryParser.T__1);
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return localctx;
	}

	public sempred(localctx: RuleContext, ruleIndex: number, predIndex: number): boolean {
		switch (ruleIndex) {
		case 0:
			return this.query_sempred(localctx as QueryContext, predIndex);
		}
		return true;
	}
	private query_sempred(localctx: QueryContext, predIndex: number): boolean {
		switch (predIndex) {
		case 0:
			return this.precpred(this._ctx, 3);
		case 1:
			return this.precpred(this._ctx, 2);
		}
		return true;
	}

	public static readonly _serializedATN: number[] = [4,1,32,124,2,0,7,0,2,
	1,7,1,2,2,7,2,2,3,7,3,2,4,7,4,2,5,7,5,2,6,7,6,2,7,7,7,2,8,7,8,1,0,1,0,1,
	0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,
	0,1,0,1,0,1,0,1,0,1,0,1,0,3,0,46,8,0,1,0,1,0,1,0,1,0,1,0,1,0,5,0,54,8,0,
	10,0,12,0,57,9,0,1,1,1,1,3,1,61,8,1,1,2,1,2,1,2,1,2,1,2,1,2,1,2,3,2,70,
	8,2,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,
	1,3,1,3,1,3,1,3,1,3,1,3,3,3,95,8,3,1,4,1,4,3,4,99,8,4,1,5,1,5,1,5,1,5,3,
	5,105,8,5,1,6,1,6,3,6,109,8,6,1,7,1,7,1,8,1,8,1,8,1,8,5,8,117,8,8,10,8,
	12,8,120,9,8,1,8,1,8,1,8,0,1,0,9,0,2,4,6,8,10,12,14,16,0,0,141,0,45,1,0,
	0,0,2,60,1,0,0,0,4,69,1,0,0,0,6,94,1,0,0,0,8,98,1,0,0,0,10,104,1,0,0,0,
	12,108,1,0,0,0,14,110,1,0,0,0,16,112,1,0,0,0,18,19,6,0,-1,0,19,20,3,4,2,
	0,20,21,3,8,4,0,21,22,3,14,7,0,22,46,1,0,0,0,23,24,3,4,2,0,24,25,3,12,6,
	0,25,26,3,16,8,0,26,46,1,0,0,0,27,28,3,6,3,0,28,29,3,8,4,0,29,30,3,14,7,
	0,30,46,1,0,0,0,31,32,3,6,3,0,32,33,3,12,6,0,33,34,3,16,8,0,34,46,1,0,0,
	0,35,36,3,6,3,0,36,37,3,10,5,0,37,38,3,14,7,0,38,46,1,0,0,0,39,40,5,16,
	0,0,40,46,3,0,0,4,41,42,5,1,0,0,42,43,3,0,0,0,43,44,5,2,0,0,44,46,1,0,0,
	0,45,18,1,0,0,0,45,23,1,0,0,0,45,27,1,0,0,0,45,31,1,0,0,0,45,35,1,0,0,0,
	45,39,1,0,0,0,45,41,1,0,0,0,46,55,1,0,0,0,47,48,10,3,0,0,48,49,5,14,0,0,
	49,54,3,0,0,4,50,51,10,2,0,0,51,52,5,15,0,0,52,54,3,0,0,3,53,47,1,0,0,0,
	53,50,1,0,0,0,54,57,1,0,0,0,55,53,1,0,0,0,55,56,1,0,0,0,56,1,1,0,0,0,57,
	55,1,0,0,0,58,61,3,4,2,0,59,61,3,6,3,0,60,58,1,0,0,0,60,59,1,0,0,0,61,3,
	1,0,0,0,62,70,5,19,0,0,63,70,5,20,0,0,64,70,5,18,0,0,65,70,5,24,0,0,66,
	70,5,25,0,0,67,70,5,26,0,0,68,70,5,30,0,0,69,62,1,0,0,0,69,63,1,0,0,0,69,
	64,1,0,0,0,69,65,1,0,0,0,69,66,1,0,0,0,69,67,1,0,0,0,69,68,1,0,0,0,70,5,
	1,0,0,0,71,95,5,21,0,0,72,95,5,17,0,0,73,95,5,27,0,0,74,75,5,22,0,0,75,
	76,5,3,0,0,76,77,3,14,7,0,77,78,5,4,0,0,78,95,1,0,0,0,79,80,5,23,0,0,80,
	81,5,3,0,0,81,82,3,14,7,0,82,83,5,4,0,0,83,95,1,0,0,0,84,85,5,28,0,0,85,
	86,5,3,0,0,86,87,3,14,7,0,87,88,5,4,0,0,88,95,1,0,0,0,89,90,5,29,0,0,90,
	91,5,3,0,0,91,92,3,14,7,0,92,93,5,4,0,0,93,95,1,0,0,0,94,71,1,0,0,0,94,
	72,1,0,0,0,94,73,1,0,0,0,94,74,1,0,0,0,94,79,1,0,0,0,94,84,1,0,0,0,94,89,
	1,0,0,0,95,7,1,0,0,0,96,99,5,6,0,0,97,99,5,7,0,0,98,96,1,0,0,0,98,97,1,
	0,0,0,99,9,1,0,0,0,100,105,5,8,0,0,101,105,5,9,0,0,102,105,5,10,0,0,103,
	105,5,11,0,0,104,100,1,0,0,0,104,101,1,0,0,0,104,102,1,0,0,0,104,103,1,
	0,0,0,105,11,1,0,0,0,106,109,5,12,0,0,107,109,5,13,0,0,108,106,1,0,0,0,
	108,107,1,0,0,0,109,13,1,0,0,0,110,111,5,31,0,0,111,15,1,0,0,0,112,113,
	5,1,0,0,113,118,3,14,7,0,114,115,5,5,0,0,115,117,3,14,7,0,116,114,1,0,0,
	0,117,120,1,0,0,0,118,116,1,0,0,0,118,119,1,0,0,0,119,121,1,0,0,0,120,118,
	1,0,0,0,121,122,5,2,0,0,122,17,1,0,0,0,10,45,53,55,60,69,94,98,104,108,
	118];

	private static __ATN: ATN;
	public static get _ATN(): ATN {
		if (!AponoQueryParser.__ATN) {
			AponoQueryParser.__ATN = new ATNDeserializer().deserialize(AponoQueryParser._serializedATN);
		}

		return AponoQueryParser.__ATN;
	}


	static DecisionsToDFA = AponoQueryParser._ATN.decisionToState.map( (ds: DecisionState, index: number) => new DFA(ds, index) );

}

export class QueryContext extends ParserRuleContext {
	constructor(parser?: AponoQueryParser, parent?: ParserRuleContext, invokingState?: number) {
		super(parent, invokingState);
    	this.parser = parser;
	}
    public get ruleIndex(): number {
    	return AponoQueryParser.RULE_query;
	}
	public override copyFrom(ctx: QueryContext): void {
		super.copyFrom(ctx);
	}
}
export class NameFieldEqualsOperatorQueryContext extends QueryContext {
	constructor(parser: AponoQueryParser, ctx: QueryContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public nameField(): NameFieldContext {
		return this.getTypedRuleContext(NameFieldContext, 0) as NameFieldContext;
	}
	public equalsOperator(): EqualsOperatorContext {
		return this.getTypedRuleContext(EqualsOperatorContext, 0) as EqualsOperatorContext;
	}
	public stringValue(): StringValueContext {
		return this.getTypedRuleContext(StringValueContext, 0) as StringValueContext;
	}
	public enterRule(listener: AponoQueryListener): void {
	    if(listener.enterNameFieldEqualsOperatorQuery) {
	 		listener.enterNameFieldEqualsOperatorQuery(this);
		}
	}
	public exitRule(listener: AponoQueryListener): void {
	    if(listener.exitNameFieldEqualsOperatorQuery) {
	 		listener.exitNameFieldEqualsOperatorQuery(this);
		}
	}
}
export class OrQueryContext extends QueryContext {
	constructor(parser: AponoQueryParser, ctx: QueryContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public query_list(): QueryContext[] {
		return this.getTypedRuleContexts(QueryContext) as QueryContext[];
	}
	public query(i: number): QueryContext {
		return this.getTypedRuleContext(QueryContext, i) as QueryContext;
	}
	public Or(): TerminalNode {
		return this.getToken(AponoQueryParser.Or, 0);
	}
	public enterRule(listener: AponoQueryListener): void {
	    if(listener.enterOrQuery) {
	 		listener.enterOrQuery(this);
		}
	}
	public exitRule(listener: AponoQueryListener): void {
	    if(listener.exitOrQuery) {
	 		listener.exitOrQuery(this);
		}
	}
}
export class NameFieldInOperatorQueryContext extends QueryContext {
	constructor(parser: AponoQueryParser, ctx: QueryContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public nameField(): NameFieldContext {
		return this.getTypedRuleContext(NameFieldContext, 0) as NameFieldContext;
	}
	public inOperator(): InOperatorContext {
		return this.getTypedRuleContext(InOperatorContext, 0) as InOperatorContext;
	}
	public stringValues(): StringValuesContext {
		return this.getTypedRuleContext(StringValuesContext, 0) as StringValuesContext;
	}
	public enterRule(listener: AponoQueryListener): void {
	    if(listener.enterNameFieldInOperatorQuery) {
	 		listener.enterNameFieldInOperatorQuery(this);
		}
	}
	public exitRule(listener: AponoQueryListener): void {
	    if(listener.exitNameFieldInOperatorQuery) {
	 		listener.exitNameFieldInOperatorQuery(this);
		}
	}
}
export class NotQueryContext extends QueryContext {
	constructor(parser: AponoQueryParser, ctx: QueryContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public Not(): TerminalNode {
		return this.getToken(AponoQueryParser.Not, 0);
	}
	public query(): QueryContext {
		return this.getTypedRuleContext(QueryContext, 0) as QueryContext;
	}
	public enterRule(listener: AponoQueryListener): void {
	    if(listener.enterNotQuery) {
	 		listener.enterNotQuery(this);
		}
	}
	public exitRule(listener: AponoQueryListener): void {
	    if(listener.exitNotQuery) {
	 		listener.exitNotQuery(this);
		}
	}
}
export class IdFieldInOperatorQueryContext extends QueryContext {
	constructor(parser: AponoQueryParser, ctx: QueryContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public idField(): IdFieldContext {
		return this.getTypedRuleContext(IdFieldContext, 0) as IdFieldContext;
	}
	public inOperator(): InOperatorContext {
		return this.getTypedRuleContext(InOperatorContext, 0) as InOperatorContext;
	}
	public stringValues(): StringValuesContext {
		return this.getTypedRuleContext(StringValuesContext, 0) as StringValuesContext;
	}
	public enterRule(listener: AponoQueryListener): void {
	    if(listener.enterIdFieldInOperatorQuery) {
	 		listener.enterIdFieldInOperatorQuery(this);
		}
	}
	public exitRule(listener: AponoQueryListener): void {
	    if(listener.exitIdFieldInOperatorQuery) {
	 		listener.exitIdFieldInOperatorQuery(this);
		}
	}
}
export class NameFieldSubstringOperatorQueryContext extends QueryContext {
	constructor(parser: AponoQueryParser, ctx: QueryContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public nameField(): NameFieldContext {
		return this.getTypedRuleContext(NameFieldContext, 0) as NameFieldContext;
	}
	public substringOperator(): SubstringOperatorContext {
		return this.getTypedRuleContext(SubstringOperatorContext, 0) as SubstringOperatorContext;
	}
	public stringValue(): StringValueContext {
		return this.getTypedRuleContext(StringValueContext, 0) as StringValueContext;
	}
	public enterRule(listener: AponoQueryListener): void {
	    if(listener.enterNameFieldSubstringOperatorQuery) {
	 		listener.enterNameFieldSubstringOperatorQuery(this);
		}
	}
	public exitRule(listener: AponoQueryListener): void {
	    if(listener.exitNameFieldSubstringOperatorQuery) {
	 		listener.exitNameFieldSubstringOperatorQuery(this);
		}
	}
}
export class ParenthesisQueryContext extends QueryContext {
	constructor(parser: AponoQueryParser, ctx: QueryContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public query(): QueryContext {
		return this.getTypedRuleContext(QueryContext, 0) as QueryContext;
	}
	public enterRule(listener: AponoQueryListener): void {
	    if(listener.enterParenthesisQuery) {
	 		listener.enterParenthesisQuery(this);
		}
	}
	public exitRule(listener: AponoQueryListener): void {
	    if(listener.exitParenthesisQuery) {
	 		listener.exitParenthesisQuery(this);
		}
	}
}
export class IdFieldEqualsOperatorQueryContext extends QueryContext {
	constructor(parser: AponoQueryParser, ctx: QueryContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public idField(): IdFieldContext {
		return this.getTypedRuleContext(IdFieldContext, 0) as IdFieldContext;
	}
	public equalsOperator(): EqualsOperatorContext {
		return this.getTypedRuleContext(EqualsOperatorContext, 0) as EqualsOperatorContext;
	}
	public stringValue(): StringValueContext {
		return this.getTypedRuleContext(StringValueContext, 0) as StringValueContext;
	}
	public enterRule(listener: AponoQueryListener): void {
	    if(listener.enterIdFieldEqualsOperatorQuery) {
	 		listener.enterIdFieldEqualsOperatorQuery(this);
		}
	}
	public exitRule(listener: AponoQueryListener): void {
	    if(listener.exitIdFieldEqualsOperatorQuery) {
	 		listener.exitIdFieldEqualsOperatorQuery(this);
		}
	}
}
export class AndQueryContext extends QueryContext {
	constructor(parser: AponoQueryParser, ctx: QueryContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public query_list(): QueryContext[] {
		return this.getTypedRuleContexts(QueryContext) as QueryContext[];
	}
	public query(i: number): QueryContext {
		return this.getTypedRuleContext(QueryContext, i) as QueryContext;
	}
	public And(): TerminalNode {
		return this.getToken(AponoQueryParser.And, 0);
	}
	public enterRule(listener: AponoQueryListener): void {
	    if(listener.enterAndQuery) {
	 		listener.enterAndQuery(this);
		}
	}
	public exitRule(listener: AponoQueryListener): void {
	    if(listener.exitAndQuery) {
	 		listener.exitAndQuery(this);
		}
	}
}


export class FieldContext extends ParserRuleContext {
	constructor(parser?: AponoQueryParser, parent?: ParserRuleContext, invokingState?: number) {
		super(parent, invokingState);
    	this.parser = parser;
	}
    public get ruleIndex(): number {
    	return AponoQueryParser.RULE_field;
	}
	public override copyFrom(ctx: FieldContext): void {
		super.copyFrom(ctx);
	}
}
export class NameFieldTypeContext extends FieldContext {
	constructor(parser: AponoQueryParser, ctx: FieldContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public nameField(): NameFieldContext {
		return this.getTypedRuleContext(NameFieldContext, 0) as NameFieldContext;
	}
	public enterRule(listener: AponoQueryListener): void {
	    if(listener.enterNameFieldType) {
	 		listener.enterNameFieldType(this);
		}
	}
	public exitRule(listener: AponoQueryListener): void {
	    if(listener.exitNameFieldType) {
	 		listener.exitNameFieldType(this);
		}
	}
}
export class IdFieldTypeContext extends FieldContext {
	constructor(parser: AponoQueryParser, ctx: FieldContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public idField(): IdFieldContext {
		return this.getTypedRuleContext(IdFieldContext, 0) as IdFieldContext;
	}
	public enterRule(listener: AponoQueryListener): void {
	    if(listener.enterIdFieldType) {
	 		listener.enterIdFieldType(this);
		}
	}
	public exitRule(listener: AponoQueryListener): void {
	    if(listener.exitIdFieldType) {
	 		listener.exitIdFieldType(this);
		}
	}
}


export class IdFieldContext extends ParserRuleContext {
	constructor(parser?: AponoQueryParser, parent?: ParserRuleContext, invokingState?: number) {
		super(parent, invokingState);
    	this.parser = parser;
	}
    public get ruleIndex(): number {
    	return AponoQueryParser.RULE_idField;
	}
	public override copyFrom(ctx: IdFieldContext): void {
		super.copyFrom(ctx);
	}
}
export class ResourceFieldContext extends IdFieldContext {
	constructor(parser: AponoQueryParser, ctx: IdFieldContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public Resource(): TerminalNode {
		return this.getToken(AponoQueryParser.Resource, 0);
	}
	public enterRule(listener: AponoQueryListener): void {
	    if(listener.enterResourceField) {
	 		listener.enterResourceField(this);
		}
	}
	public exitRule(listener: AponoQueryListener): void {
	    if(listener.exitResourceField) {
	 		listener.exitResourceField(this);
		}
	}
}
export class PermissionRiskLevelFieldContext extends IdFieldContext {
	constructor(parser: AponoQueryParser, ctx: IdFieldContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public PermissionRiskLevel(): TerminalNode {
		return this.getToken(AponoQueryParser.PermissionRiskLevel, 0);
	}
	public enterRule(listener: AponoQueryListener): void {
	    if(listener.enterPermissionRiskLevelField) {
	 		listener.enterPermissionRiskLevelField(this);
		}
	}
	public exitRule(listener: AponoQueryListener): void {
	    if(listener.exitPermissionRiskLevelField) {
	 		listener.exitPermissionRiskLevelField(this);
		}
	}
}
export class ResourceTypeFieldContext extends IdFieldContext {
	constructor(parser: AponoQueryParser, ctx: IdFieldContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public ResourceType(): TerminalNode {
		return this.getToken(AponoQueryParser.ResourceType, 0);
	}
	public enterRule(listener: AponoQueryListener): void {
	    if(listener.enterResourceTypeField) {
	 		listener.enterResourceTypeField(this);
		}
	}
	public exitRule(listener: AponoQueryListener): void {
	    if(listener.exitResourceTypeField) {
	 		listener.exitResourceTypeField(this);
		}
	}
}
export class ResourceStatusFieldContext extends IdFieldContext {
	constructor(parser: AponoQueryParser, ctx: IdFieldContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public ResourceStatus(): TerminalNode {
		return this.getToken(AponoQueryParser.ResourceStatus, 0);
	}
	public enterRule(listener: AponoQueryListener): void {
	    if(listener.enterResourceStatusField) {
	 		listener.enterResourceStatusField(this);
		}
	}
	public exitRule(listener: AponoQueryListener): void {
	    if(listener.exitResourceStatusField) {
	 		listener.exitResourceStatusField(this);
		}
	}
}
export class PermissionContext extends IdFieldContext {
	constructor(parser: AponoQueryParser, ctx: IdFieldContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public Permission(): TerminalNode {
		return this.getToken(AponoQueryParser.Permission, 0);
	}
	public enterRule(listener: AponoQueryListener): void {
	    if(listener.enterPermission) {
	 		listener.enterPermission(this);
		}
	}
	public exitRule(listener: AponoQueryListener): void {
	    if(listener.exitPermission) {
	 		listener.exitPermission(this);
		}
	}
}
export class ResourceRiskLevelFieldContext extends IdFieldContext {
	constructor(parser: AponoQueryParser, ctx: IdFieldContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public ResourceRiskLevel(): TerminalNode {
		return this.getToken(AponoQueryParser.ResourceRiskLevel, 0);
	}
	public enterRule(listener: AponoQueryListener): void {
	    if(listener.enterResourceRiskLevelField) {
	 		listener.enterResourceRiskLevelField(this);
		}
	}
	public exitRule(listener: AponoQueryListener): void {
	    if(listener.exitResourceRiskLevelField) {
	 		listener.exitResourceRiskLevelField(this);
		}
	}
}
export class IntegrationFieldContext extends IdFieldContext {
	constructor(parser: AponoQueryParser, ctx: IdFieldContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public Integration(): TerminalNode {
		return this.getToken(AponoQueryParser.Integration, 0);
	}
	public enterRule(listener: AponoQueryListener): void {
	    if(listener.enterIntegrationField) {
	 		listener.enterIntegrationField(this);
		}
	}
	public exitRule(listener: AponoQueryListener): void {
	    if(listener.exitIntegrationField) {
	 		listener.exitIntegrationField(this);
		}
	}
}


export class NameFieldContext extends ParserRuleContext {
	constructor(parser?: AponoQueryParser, parent?: ParserRuleContext, invokingState?: number) {
		super(parent, invokingState);
    	this.parser = parser;
	}
    public get ruleIndex(): number {
    	return AponoQueryParser.RULE_nameField;
	}
	public override copyFrom(ctx: NameFieldContext): void {
		super.copyFrom(ctx);
	}
}
export class ResourceNameFieldContext extends NameFieldContext {
	constructor(parser: AponoQueryParser, ctx: NameFieldContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public ResourceName(): TerminalNode {
		return this.getToken(AponoQueryParser.ResourceName, 0);
	}
	public enterRule(listener: AponoQueryListener): void {
	    if(listener.enterResourceNameField) {
	 		listener.enterResourceNameField(this);
		}
	}
	public exitRule(listener: AponoQueryListener): void {
	    if(listener.exitResourceNameField) {
	 		listener.exitResourceNameField(this);
		}
	}
}
export class PermissionContextFieldContext extends NameFieldContext {
	constructor(parser: AponoQueryParser, ctx: NameFieldContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public PermissionContext(): TerminalNode {
		return this.getToken(AponoQueryParser.PermissionContext, 0);
	}
	public stringValue(): StringValueContext {
		return this.getTypedRuleContext(StringValueContext, 0) as StringValueContext;
	}
	public enterRule(listener: AponoQueryListener): void {
	    if(listener.enterPermissionContextField) {
	 		listener.enterPermissionContextField(this);
		}
	}
	public exitRule(listener: AponoQueryListener): void {
	    if(listener.exitPermissionContextField) {
	 		listener.exitPermissionContextField(this);
		}
	}
}
export class PermissionNameFieldContext extends NameFieldContext {
	constructor(parser: AponoQueryParser, ctx: NameFieldContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public PermissionName(): TerminalNode {
		return this.getToken(AponoQueryParser.PermissionName, 0);
	}
	public enterRule(listener: AponoQueryListener): void {
	    if(listener.enterPermissionNameField) {
	 		listener.enterPermissionNameField(this);
		}
	}
	public exitRule(listener: AponoQueryListener): void {
	    if(listener.exitPermissionNameField) {
	 		listener.exitPermissionNameField(this);
		}
	}
}
export class ResourceTagFieldContext extends NameFieldContext {
	constructor(parser: AponoQueryParser, ctx: NameFieldContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public ResourceTag(): TerminalNode {
		return this.getToken(AponoQueryParser.ResourceTag, 0);
	}
	public stringValue(): StringValueContext {
		return this.getTypedRuleContext(StringValueContext, 0) as StringValueContext;
	}
	public enterRule(listener: AponoQueryListener): void {
	    if(listener.enterResourceTagField) {
	 		listener.enterResourceTagField(this);
		}
	}
	public exitRule(listener: AponoQueryListener): void {
	    if(listener.exitResourceTagField) {
	 		listener.exitResourceTagField(this);
		}
	}
}
export class ResourceContextFieldContext extends NameFieldContext {
	constructor(parser: AponoQueryParser, ctx: NameFieldContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public ResourceContext(): TerminalNode {
		return this.getToken(AponoQueryParser.ResourceContext, 0);
	}
	public stringValue(): StringValueContext {
		return this.getTypedRuleContext(StringValueContext, 0) as StringValueContext;
	}
	public enterRule(listener: AponoQueryListener): void {
	    if(listener.enterResourceContextField) {
	 		listener.enterResourceContextField(this);
		}
	}
	public exitRule(listener: AponoQueryListener): void {
	    if(listener.exitResourceContextField) {
	 		listener.exitResourceContextField(this);
		}
	}
}
export class PermissionTagFieldContext extends NameFieldContext {
	constructor(parser: AponoQueryParser, ctx: NameFieldContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public PermissionTag(): TerminalNode {
		return this.getToken(AponoQueryParser.PermissionTag, 0);
	}
	public stringValue(): StringValueContext {
		return this.getTypedRuleContext(StringValueContext, 0) as StringValueContext;
	}
	public enterRule(listener: AponoQueryListener): void {
	    if(listener.enterPermissionTagField) {
	 		listener.enterPermissionTagField(this);
		}
	}
	public exitRule(listener: AponoQueryListener): void {
	    if(listener.exitPermissionTagField) {
	 		listener.exitPermissionTagField(this);
		}
	}
}
export class IntegrationNameFieldContext extends NameFieldContext {
	constructor(parser: AponoQueryParser, ctx: NameFieldContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public IntegrationName(): TerminalNode {
		return this.getToken(AponoQueryParser.IntegrationName, 0);
	}
	public enterRule(listener: AponoQueryListener): void {
	    if(listener.enterIntegrationNameField) {
	 		listener.enterIntegrationNameField(this);
		}
	}
	public exitRule(listener: AponoQueryListener): void {
	    if(listener.exitIntegrationNameField) {
	 		listener.exitIntegrationNameField(this);
		}
	}
}


export class EqualsOperatorContext extends ParserRuleContext {
	constructor(parser?: AponoQueryParser, parent?: ParserRuleContext, invokingState?: number) {
		super(parent, invokingState);
    	this.parser = parser;
	}
    public get ruleIndex(): number {
    	return AponoQueryParser.RULE_equalsOperator;
	}
	public override copyFrom(ctx: EqualsOperatorContext): void {
		super.copyFrom(ctx);
	}
}
export class EqualsContext extends EqualsOperatorContext {
	constructor(parser: AponoQueryParser, ctx: EqualsOperatorContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public Equals(): TerminalNode {
		return this.getToken(AponoQueryParser.Equals, 0);
	}
	public enterRule(listener: AponoQueryListener): void {
	    if(listener.enterEquals) {
	 		listener.enterEquals(this);
		}
	}
	public exitRule(listener: AponoQueryListener): void {
	    if(listener.exitEquals) {
	 		listener.exitEquals(this);
		}
	}
}
export class NotEqualsContext extends EqualsOperatorContext {
	constructor(parser: AponoQueryParser, ctx: EqualsOperatorContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public NotEquals(): TerminalNode {
		return this.getToken(AponoQueryParser.NotEquals, 0);
	}
	public enterRule(listener: AponoQueryListener): void {
	    if(listener.enterNotEquals) {
	 		listener.enterNotEquals(this);
		}
	}
	public exitRule(listener: AponoQueryListener): void {
	    if(listener.exitNotEquals) {
	 		listener.exitNotEquals(this);
		}
	}
}


export class SubstringOperatorContext extends ParserRuleContext {
	constructor(parser?: AponoQueryParser, parent?: ParserRuleContext, invokingState?: number) {
		super(parent, invokingState);
    	this.parser = parser;
	}
    public get ruleIndex(): number {
    	return AponoQueryParser.RULE_substringOperator;
	}
	public override copyFrom(ctx: SubstringOperatorContext): void {
		super.copyFrom(ctx);
	}
}
export class NotContainsContext extends SubstringOperatorContext {
	constructor(parser: AponoQueryParser, ctx: SubstringOperatorContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public NotContains(): TerminalNode {
		return this.getToken(AponoQueryParser.NotContains, 0);
	}
	public enterRule(listener: AponoQueryListener): void {
	    if(listener.enterNotContains) {
	 		listener.enterNotContains(this);
		}
	}
	public exitRule(listener: AponoQueryListener): void {
	    if(listener.exitNotContains) {
	 		listener.exitNotContains(this);
		}
	}
}
export class ContainsContext extends SubstringOperatorContext {
	constructor(parser: AponoQueryParser, ctx: SubstringOperatorContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public Contains(): TerminalNode {
		return this.getToken(AponoQueryParser.Contains, 0);
	}
	public enterRule(listener: AponoQueryListener): void {
	    if(listener.enterContains) {
	 		listener.enterContains(this);
		}
	}
	public exitRule(listener: AponoQueryListener): void {
	    if(listener.exitContains) {
	 		listener.exitContains(this);
		}
	}
}
export class StartsWithContext extends SubstringOperatorContext {
	constructor(parser: AponoQueryParser, ctx: SubstringOperatorContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public StartsWith(): TerminalNode {
		return this.getToken(AponoQueryParser.StartsWith, 0);
	}
	public enterRule(listener: AponoQueryListener): void {
	    if(listener.enterStartsWith) {
	 		listener.enterStartsWith(this);
		}
	}
	public exitRule(listener: AponoQueryListener): void {
	    if(listener.exitStartsWith) {
	 		listener.exitStartsWith(this);
		}
	}
}
export class EndsWithContext extends SubstringOperatorContext {
	constructor(parser: AponoQueryParser, ctx: SubstringOperatorContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public EndsWith(): TerminalNode {
		return this.getToken(AponoQueryParser.EndsWith, 0);
	}
	public enterRule(listener: AponoQueryListener): void {
	    if(listener.enterEndsWith) {
	 		listener.enterEndsWith(this);
		}
	}
	public exitRule(listener: AponoQueryListener): void {
	    if(listener.exitEndsWith) {
	 		listener.exitEndsWith(this);
		}
	}
}


export class InOperatorContext extends ParserRuleContext {
	constructor(parser?: AponoQueryParser, parent?: ParserRuleContext, invokingState?: number) {
		super(parent, invokingState);
    	this.parser = parser;
	}
    public get ruleIndex(): number {
    	return AponoQueryParser.RULE_inOperator;
	}
	public override copyFrom(ctx: InOperatorContext): void {
		super.copyFrom(ctx);
	}
}
export class InContext extends InOperatorContext {
	constructor(parser: AponoQueryParser, ctx: InOperatorContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public In(): TerminalNode {
		return this.getToken(AponoQueryParser.In, 0);
	}
	public enterRule(listener: AponoQueryListener): void {
	    if(listener.enterIn) {
	 		listener.enterIn(this);
		}
	}
	public exitRule(listener: AponoQueryListener): void {
	    if(listener.exitIn) {
	 		listener.exitIn(this);
		}
	}
}
export class NotInContext extends InOperatorContext {
	constructor(parser: AponoQueryParser, ctx: InOperatorContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public NotIn(): TerminalNode {
		return this.getToken(AponoQueryParser.NotIn, 0);
	}
	public enterRule(listener: AponoQueryListener): void {
	    if(listener.enterNotIn) {
	 		listener.enterNotIn(this);
		}
	}
	public exitRule(listener: AponoQueryListener): void {
	    if(listener.exitNotIn) {
	 		listener.exitNotIn(this);
		}
	}
}


export class StringValueContext extends ParserRuleContext {
	constructor(parser?: AponoQueryParser, parent?: ParserRuleContext, invokingState?: number) {
		super(parent, invokingState);
    	this.parser = parser;
	}
	public QuotedString(): TerminalNode {
		return this.getToken(AponoQueryParser.QuotedString, 0);
	}
    public get ruleIndex(): number {
    	return AponoQueryParser.RULE_stringValue;
	}
	public enterRule(listener: AponoQueryListener): void {
	    if(listener.enterStringValue) {
	 		listener.enterStringValue(this);
		}
	}
	public exitRule(listener: AponoQueryListener): void {
	    if(listener.exitStringValue) {
	 		listener.exitStringValue(this);
		}
	}
}


export class StringValuesContext extends ParserRuleContext {
	constructor(parser?: AponoQueryParser, parent?: ParserRuleContext, invokingState?: number) {
		super(parent, invokingState);
    	this.parser = parser;
	}
	public stringValue_list(): StringValueContext[] {
		return this.getTypedRuleContexts(StringValueContext) as StringValueContext[];
	}
	public stringValue(i: number): StringValueContext {
		return this.getTypedRuleContext(StringValueContext, i) as StringValueContext;
	}
    public get ruleIndex(): number {
    	return AponoQueryParser.RULE_stringValues;
	}
	public enterRule(listener: AponoQueryListener): void {
	    if(listener.enterStringValues) {
	 		listener.enterStringValues(this);
		}
	}
	public exitRule(listener: AponoQueryListener): void {
	    if(listener.exitStringValues) {
	 		listener.exitStringValues(this);
		}
	}
}
